function initTakeMeBack() {
  const els = document.querySelectorAll<HTMLElement>('.take-me-back')
  for (const el of els) {
    el.onclick = () => {
      window.history.back()
    }
  }
}

export { initTakeMeBack }
